import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RegistrationState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
}

const initialState: RegistrationState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
};

type RegistrationTextField = 
  'firstName' | 'lastName' | 'email' | 'phone' | 'password' | 'confirmPassword';

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    updateField(
      state,
      action: PayloadAction<{ field: RegistrationTextField; value: string }>
    ) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    clearRegisterForm() {
      return initialState;
    },
  },
});

export const { updateField, clearRegisterForm } = registrationSlice.actions;
export default registrationSlice.reducer;
